<script>
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch";
import { CityPath } from "@/path.js";
import { RestaurantsPath, USERSPATH } from "../../../../../path";
import axios from "axios";
import Swal from "sweetalert2";
export default {
  props: ["selectedUser"],
  name: "add",
  data() {
    return {
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      restaurants: [],
      currentPage: 1,
      search: "",
      department: "",
      account_type: "",
      fields: ["name", "city", "edit"],
      roles: [],
      permissions: [],
      form: { role: null },
      filter: [],
      key: 1,
    };
  },
  computed: {
    CityPath() {
      return CityPath;
    },
  },
  components: {
    "select-with-search": SelectWithSearch,
  },
  watch: {
    currentPage() {
      this.getRestaurants();
    },
    search() {
      this.getRestaurants();
    },
    "form.role"() {
      this.key += 1;
    },
  },
  methods: {
    async getRestaurants() {
      try {
        let response = await axios.get(
          this.base_url + RestaurantsPath.BASIC_RESTAURENT,
          {
            params: {
              page: this.currentPage,
              search: this.search,
              city: this.form.city,
            },
          }
        );
        if (response.data.status == true) {
          this.restaurants = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPermissions() {
      try {
        let res = await axios.get(this.base_url + USERSPATH.GET_PERMISSIOINS);
        if (res.data.status) {
          this.permissions = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRoles() {
      try {
        let res = await axios.get(this.base_url + USERSPATH.GET_ROLES);
        if (res.data.status) {
          this.roles = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCities() {
      try {
        let res = await axios.get(this.base_url + CityPath.GET_CITY);
        if (res.data.data) {
          if (this.selectedUser.city) {
            res.data.data.forEach((city) => {
              if (city.id == this.selectedUser.city) {
                this.form.city = city.city;
              }
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    setRole(v) {
      this.form.role = v;
    },
    addRestaurant(v) {
      if (
        this.form.restaurant_ids != undefined &&
        this.form.restaurant_ids.length > 0
      ) {
        if (this.form.restaurant_ids.filter((f) => f == v.id).length == 0) {
          this.form.restaurant_ids.push(v.id);
        }
      } else {
        this.form.restaurant_ids = [v.id];
      }
      this.key += 1;
    },
    removeRestaurant(v) {
      if (this.form.restaurant_ids && this.form.restaurant_ids.length > 0) {
        this.form.restaurant_ids = this.form.restaurant_ids.filter(
          (f) => f != v.id
        );
      }
      this.key += 1;
    },
    async saveUser() {
      try {
        if (this.selectedUser) {
          this.form.id = this.selectedUser.id;
        }
        let res = await axios.post(
          this.base_url + USERSPATH.SAVE_USER,
          this.form
        );
        if (res.data.status) {
          Swal.fire("Success", "", "success");
          this.$emit("update");
        } else {
          throw new Error(res.data.message);
        }
      } catch (error) {
        console.log(error);
        Swal.fire(error, "", "error");
      }
    },
  },
  mounted() {
    this.getRestaurants();
    this.getPermissions();
    this.getRoles();
    this.getCities();
    if (this.selectedUser) {
      if (this.selectedUser.roles[0].id == 4) {
        this.form.restaurant_ids = this.selectedUser.am_restaurants?.map(
          (r) => r.id
        );
      } else if (this.selectedUser.roles[0].id == 5) {
        this.form.restaurant_ids = this.selectedUser.ac_restaurants?.map(
          (r) => r.id
        );
      }
      this.form.name = this.selectedUser.name;
      this.form.email = this.selectedUser.email;
      this.form.city = this.selectedUser.city;
      this.form.role = this.selectedUser.roles[0].id;
      // this.form.permissions = this.selectedUser.permissions.map(p => p.id);
      this.key += 1;
    }
  },
};
</script>

<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-tabs pills card>
        <b-tab title="User Details" active>
          <b-container fluid="sm">
            <b-row class="my-1">
              <b-col sm="6">
                <label>Name:</label>
                <b-form-input
                  id="input-small"
                  v-model="form.name"
                  size="sm"
                  placeholder="Enter your name"
                ></b-form-input>
              </b-col>
              <b-col sm="6">
                <label>Email:</label>
                <b-form-input
                  id="input-small"
                  v-model="form.email"
                  size="sm"
                  placeholder="Enter Email"
                ></b-form-input>
              </b-col>
              <b-col sm="6">
                <label>Password: (leave Empty not to change)</label>
                <b-form-input
                  id="input-small"
                  v-model="form.password"
                  size="sm"
                  placeholder="Enter Password"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="6">
                <label>Role:</label>
                <select-with-search
                  :search_without_api="true"
                  track_by="id"
                  display="name"
                  :selected_data="[form.role]"
                  selected_by="id"
                  :optionsData="roles"
                  @selectedOption="setRole"
                ></select-with-search>
              </b-col>
              <b-col sm="6">
                <label>City:</label>
                <select-with-search
                  :search_api="CityPath.GET_CITY"
                  track_by="id"
                  display="city"
                  :selected_data="[form.city]"
                  selected_by="city"
                  :extra_params="'&name=' + form.city"
                  @selectedOption="(v) => (form.city = v)"
                ></select-with-search>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <!-- <b-col sm="6" v-if="permissions.length > 0">
                <label>Permission:</label>
                <select-with-search                  
                  :search_without_api="true"
                  track_by="id"                  
                  display="name"
                  selected_by="id"
                  :selected_data="form.permissions"
                  :optionsData="permissions"           
                  :multi_select="true"       
                  @selectedOption="(v) => (form.permissions = v)"
                ></select-with-search>
              </b-col> -->
            </b-row>
            <b-row class="my-1 mt-2">
              <b-col sm="12">
                <b-button @click="saveUser" class="btn btn-success"
                  >Submit</b-button
                >
              </b-col>
            </b-row>
          </b-container>
        </b-tab>
        <b-tab title="Map Restaurants" @click="getRestaurants">
          <b-container fluid="sm">
            <div class="col-sm-12 col-md-12">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right"
              >
                <label class="d-inline-flex align-items-center mr-5">
                  Search:
                  <b-form-input
                    v-model="search"
                    type="search"
                    debounce="300"
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                  <!-- <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> -->
                </label>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="restaurants.key"
                :items="restaurants.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
              >
                <template v-slot:cell(edit)="row">
                  <div :key="key + 1">
                    <b-button
                      variant="success"
                      v-if="
                        (form.restaurant_ids != undefined &&
                          form.restaurant_ids.filter((f) => f == row.item.id)
                            .length == 0) ||
                        form.restaurant_ids == undefined
                      "
                      @click="addRestaurant(row.item)"
                      >+</b-button
                    >
                    <b-button
                      variant="danger"
                      v-else
                      @click="removeRestaurant(row.item)"
                      >-</b-button
                    >
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="restaurants.key"
                      v-model="currentPage"
                      :total-rows="restaurants.total"
                      :per-page="restaurants.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <b-row class="my-1 mt-2">
              <b-col sm="12">
                <b-button @click="saveUser" class="btn btn-success"
                  >Submit</b-button
                >
              </b-col>
            </b-row>
          </b-container>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<style></style>
